export default "__VITE_ASSET__DDAM11lM__"